import styled, { keyframes } from 'styled-components'
import { tokens } from '@welbe/web-design-system'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

type RadioProps = {
	isActive?: boolean
	error?: boolean
	disabled: boolean
	variant: 'primary' | 'secondary'
	size: 'small' | 'medium' | 'large'
}

const getColor = (variant: string, disabled: boolean) => {
	if (!disabled) {
		const colors: any = {
			primary: tokens.color_primary,
			secondary: tokens.color_secondary,
		}

		return colors[variant]
	}

	return tokens.color_ink_lighter
}

const getSize = (type: string, size: string) => {
	const sizes: any = {
		circleArea: {
			small: '21px',
			medium: '26px',
			large: '30px',
		},
		check: {
			small: '12px',
			medium: '18px',
			large: '20px',
		},
		right: {
			small: '18.5px',
			medium: '18.1px',
			large: '19px',
		},
	}

	return sizes[type][size]
}

export const Container = styled.div<RadioProps>`
	display: flex;
	cursor: pointer;
	height: 100%;
	font-family: ${tokens.font_family_primary};

	input {
		position: absolute !important;
		height: 1px;
		width: 1px;
		overflow: hidden;
		clip: rect(1px 1px 1px 1px);
		clip: rect(1px, 1px, 1px, 1px);
		cursor: pointer;
	}

	label {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		font-family: ${tokens.font_family_primary};
		cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.container-radio {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 2px solid
			${({ isActive, variant, error, disabled }) =>
				isActive ? getColor(variant, disabled) : error ? '#C22A58' : '#DADADA'};
		height: ${({ size }) => getSize('circleArea', size)};
		width: ${({ size }) => getSize('circleArea', size)};
		border-radius: 50%;
		margin: 6px 12px;
	}

	.checked {
		background-color: ${({ isActive, variant, error, disabled }) =>
			isActive ? getColor(variant, disabled) : error ? '#C22A58' : '#DADADA'};
		width: ${({ size }) => getSize('check', size)};
		height: ${({ size }) => getSize('check', size)};
		border-radius: 50%;
		display: ${props => (!props.isActive ? 'none' : 'block')};
		opacity: ${props => (!props.isActive ? 0 : 1)};
		animation: ${props => (!props.isActive ? fadeOut : fadeIn)};
		animation-fill-mode: both;
		animation-duration: 0.3s;
	}

	input[type='radio']:focus + label {
		.container-radio {
			outline: 2px solid ${tokens.color_gray_dark};
		}
	}
`
